// Utility to standardise employer / organisation names in Proper Case
// with sensible handling for common company suffixes.

const UPPERCASE_WORDS = new Set(['llp', 'plc', 'llc']);

const SPECIAL_WORDS = new Map([
  ['pvt', 'Pvt'],
  ['pvt.', 'Pvt.'],
  ['ltd', 'Ltd'],
  ['ltd.', 'Ltd.'],
  ['inc', 'Inc'],
  ['inc.', 'Inc.'],
  ['co', 'Co'],
  ['co.', 'Co.'],
]);

const MINOR_WORDS = new Set(['of', 'and', 'the', 'for', 'in', 'on', 'at']);

const capitalizeWord = (word) => {
  if (!word) return '';

  const lower = word.toLowerCase();

  // Strip punctuation for matching but preserve it when rebuilding
  const match = lower.match(/^([a-z]+)([.,]*)$/i);
  const base = match ? match[1] : lower;
  const punct = match ? match[2] : '';

  if (UPPERCASE_WORDS.has(base)) {
    return base.toUpperCase() + punct;
  }

  if (SPECIAL_WORDS.has(base)) {
    return SPECIAL_WORDS.get(base) + punct;
  }

  if (MINOR_WORDS.has(base)) {
    return base + punct;
  }

  // Handle hyphenated words like "co-operative"
  if (base.includes('-')) {
    return base
      .split('-')
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join('-') + punct;
  }

  return base.charAt(0).toUpperCase() + base.slice(1) + punct;
};

export const formatEmployerName = (rawName) => {
  if (!rawName || typeof rawName !== 'string') return '';

  const trimmed = rawName.trim();
  if (!trimmed) return '';

  return trimmed
    .split(/\s+/)
    .map(capitalizeWord)
    .join(' ');
};

export default formatEmployerName;

